import { render, staticRenderFns } from "./MantenedorDocumentos.vue?vue&type=template&id=24f41c56&scoped=true&"
import script from "./MantenedorDocumentos.vue?vue&type=script&lang=js&"
export * from "./MantenedorDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./MantenedorDocumentos.vue?vue&type=style&index=0&id=24f41c56&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f41c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f41c56')) {
      api.createRecord('24f41c56', component.options)
    } else {
      api.reload('24f41c56', component.options)
    }
    module.hot.accept("./MantenedorDocumentos.vue?vue&type=template&id=24f41c56&scoped=true&", function () {
      api.rerender('24f41c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MantenedorDocumentos.vue"
export default component.exports